import html2canvas from 'html2canvas';

export const takeSnapshot = async (): Promise<Blob | null> => {
  return new Promise((res, rej) => {
    html2canvas(document.body)
      .then((canvas) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            rej(null);
          }
          res(blob);
        });
      })
      .catch(() => rej(null));
  });
};
